import React from 'react';
import PropTypes from 'prop-types';
import style from './style.scss'; //NOSONAR

const Checkbox = ({ type = "checkbox", name, checked = false, onChange, disabled = false }) => {
    return (
        <div className="check-button-container">
            <input type={type} name={name} checked={checked} onChange={onChange} className={'check-button-item' + (disabled ? ' disabled' : '')}/>
        </div>
    );
};

Checkbox.propTypes = {
    type: PropTypes.string,
    name: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func
};

export default Checkbox;
